import React, { useState, useEffect } from "react";
import {
  AuxDiv,
  ShortDiv,
  StyledButton,
  StyledDiv,
  StyledDiv2,
  StyledDiv3,
  StyledGrandDiv,
  StyledText,
  DivSeparator,
  ButtonDiv,
  Content,
} from "./styles";
import Button from "../Button";
import ArrowDown from "../../../assets/icons/arrow-down";
import Logo from "../../../assets/icons/Logo";
import FullLogo from "../../../assets/icons/FullLogo";
import Flash from "../../../assets/icons/Flash";
import TasksIcon from "../../../assets/icons/TasksIcon";
import FlowIcon from "../../../assets/icons/FlowIcon";
import UsersIcon from "../../../assets/icons/UsersIcon";
import FlashSlash from "../../../assets/icons/FlashSlash";
import FlashCircle from "../../../assets/icons/FlashCircle";
import DashboardIcon from "../../../assets/icons/DashboardIcon";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { pathTo } from "../../../state/zaivuPersist/slice";
import { openModal } from "../../../state/zaivuPersist/slice";

const ProtectedComponent = ({
  name,
  menuOpen,
  path,
  statePath,
  allowedRanks,
  Icon,
}) => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));
  const isAllowed = allowedRanks.includes(user?.rank);

  return isAllowed ? (
    <AuxDiv style={{ marginBottom: "2rem" }}>
      {statePath === path || (statePath === "" && <ShortDiv />)}
      <StyledText
        hideMenu={menuOpen}
        actived={statePath === path}
        onClick={() => {
          history.push(path);
        }}
      >
        <StyledDiv3 hideMenu={menuOpen}>
          <Icon />
          {!menuOpen && <span style={{ marginLeft: "11px" }}>{name}</span>}
        </StyledDiv3>
      </StyledText>
    </AuxDiv>
  ) : null;
};

const Menu = () => {
  const history = useHistory();

  const [menuOpen, setMenuOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const state = useSelector((state) => state.zaivuPersist);

  const dispatch = useDispatch();

  useEffect(() => {
    if (history) {
      dispatch(pathTo(history.location.pathname));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <StyledGrandDiv hideMenu={menuOpen}>
      <StyledDiv hideMenu={menuOpen}>
        <DivSeparator>
          <StyledDiv2 style={{ cursor: "pointer" }}>
            {menuOpen ? <Logo /> : <FullLogo />}
          </StyledDiv2>

          <StyledButton hideMenu={menuOpen}>
            <Button
              style={{ zIndex: "9" }}
              round
              Icon={() => <ArrowDown />}
              size="46px"
              background="#7E858F"
              onClick={() => setMenuOpen(!menuOpen)}
            />
          </StyledButton>

          {user?.rank !== "colaborador" ? (
            <ButtonDiv>
              <Button
                style={{
                  maxWidth: menuOpen ? "57px" : "211px",
                  width: "211px",
                  height: "57px",
                  transition: "0.4s ease-out",
                }}
                content={menuOpen ? null : "Iniciar Fluxo"}
                greenBase
                iconSize="25px"
                fontSize="17px"
                lineHeight="21px"
                Icon={() => <Flash />}
                onClick={() => {
                  dispatch(openModal());
                }}
              />
            </ButtonDiv>
          ) : null}
          <Content>
            <ProtectedComponent
              name="Dashboard"
              path="/dashboard"
              menuOpen={menuOpen}
              statePath={state.menu.path}
              allowedRanks={["gerente", "admin", "colaborador"]}
              Icon={() => (
                <DashboardIcon style={{ width: "24px", height: "24px" }} />
              )}
            />

            <ProtectedComponent
              name="Tarefas"
              path="/tasks"
              menuOpen={menuOpen}
              statePath={state.menu.path}
              allowedRanks={["gerente", "admin", "colaborador"]}
              Icon={() => <TasksIcon />}
            />
            <ProtectedComponent
              name="Fluxos Iniciados"
              path="/activedflows"
              menuOpen={menuOpen}
              statePath={state.menu.path}
              allowedRanks={["gerente", "admin", "colaborador"]}
              Icon={() => <FlashCircle />}
            />
            <ProtectedComponent
              name="RDMs"
              path="/rdm"
              menuOpen={menuOpen}
              statePath={state.menu.path}
              allowedRanks={["gerente", "admin", "colaborador"]}
              Icon={() => <FlashCircle />}
            />
            <ProtectedComponent
              name="Fluxos Modelos"
              path="/modelflows"
              menuOpen={menuOpen}
              statePath={state.menu.path}
              allowedRanks={["gerente", "admin"]}
              Icon={() => <FlowIcon />}
            />

            <ProtectedComponent
              name="Fluxos Encerrados"
              path="/finishedFlows"
              menuOpen={menuOpen}
              statePath={state.menu.path}
              allowedRanks={["gerente", "admin"]}
              Icon={() => <FlashSlash />}
            />
            <ProtectedComponent
              name="Membros"
              path="/members"
              menuOpen={menuOpen}
              statePath={state.menu.path}
              allowedRanks={["gerente", "admin", "colaborador"]}
              Icon={() => <UsersIcon />}
            />
            <ProtectedComponent
              name="Estatística de Usuário"
              path="/userstats"
              menuOpen={menuOpen}
              statePath={state.menu.path}
              allowedRanks={["gerente", "admin", "colaborador"]}
              Icon={() => <UsersIcon />}
            />
          </Content>
        </DivSeparator>
      </StyledDiv>
    </StyledGrandDiv>
  );
};

export default Menu;
